<template>
  <ul class="password-requirements-checklist">
    <li
      v-for="requirement of requirements"
      :key="requirement.label"
      class="d-flex align-center mb-1"
    >
      <v-icon
        :color="requirement.valid ? 'success' : 'error'"
        size="18"
        class="mr-2"
      >
        {{ requirement.valid ? 'mdi-check' : 'mdi-close' }}
      </v-icon>
      <span :class="requirement.valid ? 'success--text' : 'error--text'">
        {{ requirement.label }}
      </span>
    </li>
  </ul>
</template>

<script>
import { rules } from '@/utilities/validation-rules'

export default {
  name: 'PasswordRequirementsChecklist',

  props: {
    password: {
      type: String,
      default: '',
    },
  },

  computed: {
    requirements () {
      return [
        {
          label: 'At least 16 characters',
          valid: rules.passwordMinLength(this.password) === true,
        },
        {
          label: 'One number',
          valid: rules.passwordHasNumber(this.password) === true,
        },
        {
          label: 'One special character',
          valid: rules.passwordHasSpecialChar(this.password) === true,
        },
        {
          label: 'No leading or trailing spaces',
          valid: rules.passwordNoLeadingOrTrailingSpace(this.password) === true,
        },
      ]
    },
  },
}
</script>

<style scoped>
.password-requirements-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
